import React from 'react';
import { Text4,Text3,  } from '../../../styles';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Button, Descriptions } from 'antd';
import { printRupee } from '../../../app_methods';

const PaymentBreakupDrawer = (props) => {
    const direct_tax = props.direct_tax || {};

    
    return (
        <EaseDrawer
            className="payment-breakup-drawer-wrapper"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={500}
        >
            <div className="mt-4">
                <Text3 className="d-block" strong>Payment Details</Text3>
                <Descriptions className='mt-2' title={false} column={1} bordered size="small">
                    <Descriptions.Item label="Tax Amount">{printRupee(direct_tax.income_tax)}</Descriptions.Item>

                    <Descriptions.Item label="Education Cess Amount">{printRupee(direct_tax.education_cess)}</Descriptions.Item>
                    <Descriptions.Item label="Equilization Levy Amount">{printRupee(direct_tax.equilization_levy)}</Descriptions.Item>
                    <Descriptions.Item label="Interest Amount">{printRupee(direct_tax.interest)}</Descriptions.Item>
                    <Descriptions.Item label="Penalty Amount">{printRupee(direct_tax.penalty)}{' '}{direct_tax.penalty_code? (direct_tax.penalty_code) : null }</Descriptions.Item>
                    <Descriptions.Item label="Surcharge Amount">{printRupee(direct_tax.surcharge)}</Descriptions.Item>
                    <Descriptions.Item label="Other Amount">{printRupee(direct_tax.other_amount)}</Descriptions.Item>
                    <Descriptions.Item label="Other Fee Amount">{printRupee(direct_tax.other_fee)}</Descriptions.Item>

                    <Descriptions.Item label="Total Amount"><strong>{printRupee(direct_tax.total_amount)}</strong></Descriptions.Item>
                </Descriptions>
            </div>
        </EaseDrawer>
    )
};

export { PaymentBreakupDrawer };